import { generateSourcesForPicture } from '@farmersdog/corgi-x';

import cbsWebP from './cbs-news-logo.webp';
import cbsPng from './cbs-news-logo.png';
import cbsKaleWebP from './cbs-news-logo-kale.webp';
import cbsKalePng from './cbs-news-logo-kale.png';

import vogueWebP from './vogue-logo.webp';
import voguePng from './vogue-logo.png';
import vogueKaleWebP from './vogue-logo-kale.webp';
import vogueKalePng from './vogue-logo-kale.png';

import fastCompanyWebP from './fast-company-logo.webp';
import fastCompanyPng from './fast-company-logo.png';
import fastCompanyKaleWebP from './fast-company-logo-kale.webp';
import fastCompanyKalePng from './fast-company-logo-kale.png';

import todayShowWebP from './today-show-logo.webp';
import todayShowPng from './today-show-logo.png';
import todayShowKaleWebP from './today-show-logo-kale.webp';
import todayShowKalePng from './today-show-logo-kale.png';

export const cbsSources = generateSourcesForPicture({
  desktopSources: { webP: cbsWebP, png: cbsPng },
  mobileSources: { webP: cbsWebP, png: cbsPng },
});

export const cbsSourcesKale = generateSourcesForPicture({
  desktopSources: { webP: cbsKaleWebP, png: cbsKalePng },
  mobileSources: { webP: cbsKaleWebP, png: cbsKalePng },
});

export const vogueSources = generateSourcesForPicture({
  desktopSources: { webP: vogueWebP, png: voguePng },
  mobileSources: { webP: vogueWebP, png: voguePng },
});

export const vogueSourcesKale = generateSourcesForPicture({
  desktopSources: { webP: vogueKaleWebP, png: vogueKalePng },
  mobileSources: { webP: vogueKaleWebP, png: vogueKalePng },
});

export const fastCompanySources = generateSourcesForPicture({
  desktopSources: { webP: fastCompanyWebP, png: fastCompanyPng },
  mobileSources: { webP: fastCompanyWebP, png: fastCompanyPng },
});

export const fastCompanySourcesKale = generateSourcesForPicture({
  desktopSources: { webP: fastCompanyKaleWebP, png: fastCompanyKalePng },
  mobileSources: { webP: fastCompanyKaleWebP, png: fastCompanyKalePng },
});

export const todayShowSources = generateSourcesForPicture({
  desktopSources: { webP: todayShowWebP, png: todayShowPng },
  mobileSources: { webP: todayShowWebP, png: todayShowPng },
});

export const todayShowSourcesKale = generateSourcesForPicture({
  desktopSources: { webP: todayShowKaleWebP, png: todayShowKalePng },
  mobileSources: { webP: todayShowKaleWebP, png: todayShowKalePng },
});
